import * as z from "zod";
import { gql } from "graphql-request";

import { Sys, SysFragment } from "./sys";
import { Targeting, TargetingFragment } from "./targeting";
import { RelatedMedia, RelatedMediaFragment } from "./relatedMedia";
import {
  CarouselEventEntry,
  CarouselEventEntryFragment,
} from "./newsEntryTypes/carouselEventEntry";
import {
  CarouselEventPollEntry,
  CarouselEventPollEntryFragment,
} from "./newsEntryTypes/carouselEventPollEntry";

import {
  CarouselEventPollTargetsEntry,
  CarouselEventPollTargetsEntryFragment,
} from "./newsEntryTypes/carouselEventPollTargetsEntry";

import {
  CarouselEventProgressTrackerEntryFragment,
  CarouselEventProgressTrackerEntry,
} from "./newsEntryTypes/carouselEventProgressTrackerEntry";

export const EventEntry = z.object({
  __typename: z.literal("CarouselEvent"),
  sys: Sys,
  sortDate: z.string().nullable(),
  targeting: Targeting.nullable(),
  relatedMedia: RelatedMedia.nullable(),
  localized: z
    .discriminatedUnion("__typename", [
      CarouselEventEntry,
      CarouselEventPollEntry,
      CarouselEventPollTargetsEntry,
      CarouselEventProgressTrackerEntry,
    ])
    .nullish(),
});

export type EventEntry = z.infer<typeof EventEntry>;

export const EventEntryFragment = gql`
  fragment EventEntryFragment on CarouselEvent {
    __typename

    sys {
      ...SysFragment
    }

    targeting {
      ...TargetingFragment
    }

    relatedMedia {
      ...RelatedMediaFragment
    }

    sortDate
    localized {
      ... on CarouselEventEntry {
        ...CarouselEventEntryFragment
      }
      ... on CarouselEventPollEntry {
        ...CarouselEventPollEntryFragment
      }
      ... on CarouselEventPollTargetsEntry {
        ...CarouselEventPollTargetsEntryFragment
      }
      ... on CarouselEventProgressTrackerEntry {
        ...CarouselEventProgressTrackerEntryFragment
      }
    }
  }

  ${SysFragment}
  ${CarouselEventEntryFragment}
  ${CarouselEventPollEntryFragment}
  ${CarouselEventPollTargetsEntryFragment}
  ${CarouselEventProgressTrackerEntryFragment}
  ${TargetingFragment}
  ${RelatedMediaFragment}
`;
